import { Field, Int, ObjectType } from 'type-graphql'

@ObjectType({ description: 'A single component difference between two board versions.' })
export class BoardComponentDiff {
  @Field(type => Int, { nullable: true, description: 'The refid of the component (identity used for diffing).' })
  refid?: number | null

  @Field({ nullable: true, description: 'The component type (e.g. rect, text, table).' })
  type?: string

  @Field({ description: "The kind of change: 'added', 'removed', or 'modified'." })
  changeType: 'added' | 'removed' | 'modified'

  @Field(type => [String], {
    nullable: true,
    description: 'Names of the properties that changed (for modified components).'
  })
  changedProps?: string[]
}

@ObjectType({ description: 'The difference between two board versions (or a version and the current draft).' })
export class BoardVersionDiff {
  @Field(type => Int, { description: 'The base version number being compared from.' })
  fromVersion: number

  @Field(type => Int, {
    nullable: true,
    description: 'The target version number being compared to. Null means the current draft.'
  })
  toVersion?: number | null

  @Field(type => Int, { description: 'Number of components added.' })
  addedCount: number

  @Field(type => Int, { description: 'Number of components removed.' })
  removedCount: number

  @Field(type => Int, { description: 'Number of components modified.' })
  modifiedCount: number

  @Field(type => [BoardComponentDiff], { description: 'Component-level changes.' })
  componentDiffs: BoardComponentDiff[]
}
